module.exports = __webpack_public_path__ + "img/banner10.05dada4e.jpg";